function useMyTeamTimestamp() {
  return {};
}

export default useMyTeamTimestamp;
